import { render, staticRenderFns } from "./LeagueMyViewer.vue?vue&type=template&id=575f2a48&"
import script from "./LeagueMyViewer.vue?vue&type=script&lang=js&"
export * from "./LeagueMyViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports